<div [class.kal-form-field--error]="hasError"
     class="kal-form-field__wrapper">

  <label [attr.for]="for"
         [class.kal-form-field--required]="required"
         class="kal-form-field__label">
    <ng-container *ngIf="!labelTemplate else labelTemplate?.templateRef">{{ label }}</ng-container>&nbsp;
  </label>

  <div *ngIf="legend" class="kal-form-field__legend">{{ legend }}</div>
  <ng-content></ng-content>

  <!--  display errors -->
  <ul *ngIf="showError && hasError" class="kal-form-field--errors-list">
    <li *ngFor="let error of errors|keyvalue">
      {{ getErrorMessage(error) }}
    </li>
  </ul>

</div>
